import ItemDatePicker from "@/modules/front/ItemDatePicker";
import React from "react";
import {useForm} from "react-hook-form";
import {Button, Form} from "react-bootstrap";
import FormProgress from "@/modules/front/ReservationExternal/FormProgress";

const ReservationExternalStep1 = ({personalData, ...props}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},

    } = useForm({
        defaultValues: personalData
    });

    const onSubmit = (data) => {
        console.log(data);
        props.onPersonalDataSubmitted(data);
    };

    let submitBtn = <div onClick={() => {
        props.onError('Pro pokračování vyberte volný termín v kalendáři.')
    }}><Button
        className={'btn btn-primary px-4 py-2 rounded-0 disabled'}

    >Pokračovat <i className="fas fa-chevron-right ms-3"></i></Button></div>;
    if (props.dateFrom && props.dateTo) {
        submitBtn = <Button className={'btn btn-primary px-4 py-2 rounded-0'} type="submit" variant="primary">
            Pokračovat <i className="fas fa-chevron-right ms-3"></i>
        </Button>
    }

    return <div>
        <div className={'text-center'}>
            <ItemDatePicker
                locale={props.locale}
                offices={props.offices}
                office={props.office}
                lockOffice={props.lockOffice}
                onDateConfirmed={props.onDateConfirmed}
                addToCartLabel={false}
                itemId={props.itemId}
            />
        </div>
        <FormProgress
            steps={[window.translations.reservationExternal.steps.personalInfo, window.translations.reservationExternal.steps.summary]}
            currentStep={1}/>
        <form className={'mt-4'} onSubmit={handleSubmit(onSubmit)}>
            <div className={'row'}>
                <div className={'col-md-6'}>
                    <Form.Group className="mb-2" controlId="firstname">
                        <Form.Label>Jméno</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("firstname", {
                                required: "Zadejte prosím vaše jméno.",
                            })}
                        />
                        {errors.firstname && <p className="text-danger">{errors.firstname.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-md-6'}>
                    <Form.Group className="mb-2" controlId="lastname">
                        <Form.Label>Příjmení</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("lastname", {
                                required: "Zadejte prosím vaše příjmení.",
                            })}
                        />
                        {errors.lastname && <p className="text-danger">{errors.lastname.message}</p>}
                    </Form.Group>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-md-6'}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control
                            type="email"
                            {...register("email", {
                                required: "Zadejte prosím váš e-mail",
                                pattern: {
                                    value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                    message: "Zadaná e-mailová adresa není platná."
                                }
                            })}
                        />
                        {errors.email && <p className="text-danger">{errors.email.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-md-6'}>
                    <Form.Group className="mb-3" controlId="phone">
                        <Form.Label>Telefon</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("phone", {
                                required: "Zadejte prosím váš telefon."
                            })}
                        />
                        {errors.phone && <p className="text-danger">{errors.phone.message}</p>}
                    </Form.Group>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-md-5'}>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Adresa a č.p.</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("address", {
                                required: "Zadejte prosím vaši adresu.",
                            })}
                        />
                        {errors.address && <p className="text-danger">{errors.address.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-md-4'}>
                    <Form.Group className="mb-3" controlId="city">
                        <Form.Label>Město</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("city", {
                                required: "Zadejte prosím město."
                            })}
                        />
                        {errors.city && <p className="text-danger">{errors.city.message}</p>}
                    </Form.Group>
                </div>
                <div className={'col-md-3'}>
                    <Form.Group className="mb-3" controlId="zip">
                        <Form.Label>PSČ</Form.Label>
                        <Form.Control
                            type="text"
                            {...register("zip", {
                                required: "Zadejte prosím PSČ."
                            })}
                        />
                        {errors.zip && <p className="text-danger">{errors.zip.message}</p>}
                    </Form.Group>
                </div>
            </div>

            <label></label>
            <div className={'text-end'}>
                {submitBtn}
            </div>
        </form>

    </div>;
};

export default ReservationExternalStep1;